var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.412,
    height: 29.413,
    viewBox: "0 0 29.412 29.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-commission-2070169",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11450",
    "data-name": "Path 11450",
    d: "M206.6,82.337v-6.27a7.849,7.849,0,0,0-5.13-7.349l1.656-3.726h0a.49.49,0,0,0-.329-.674l-1.056-.265a3.017,3.017,0,0,0-2.076.228,2.051,2.051,0,0,1-.908.214v.98a3.035,3.035,0,0,0,1.346-.318A2.034,2.034,0,0,1,201.5,65l.49.123-1.471,3.305h0a7.806,7.806,0,0,0-1.765-.208v.98a6.87,6.87,0,0,1,6.863,6.863v6.079a6.106,6.106,0,0,0-3.6.717l-.124.068H198.27a1.961,1.961,0,0,0-1.892,2.475l-3.956-1.814a1.867,1.867,0,0,0-.525-.142V76.067a6.865,6.865,0,0,1,.245-1.83l-.945-.262a7.855,7.855,0,0,0-.28,2.092v7.511a1.841,1.841,0,0,0-1,1.016,1.869,1.869,0,0,0,.776,2.3l5.643,3.386a3.431,3.431,0,0,0,1.765.49h15.363v-.98h-4.412V84.4h4.412v-.98h-4.735a6.133,6.133,0,0,0-2.128-1.083Zm-9.76,7.108L191.2,86.058a.891.891,0,0,1-.371-1.1.878.878,0,0,1,1.184-.474l5.072,2.323a.486.486,0,0,0,.2.045h4.9a.49.49,0,0,0,0-.98H198.27a.98.98,0,1,1,0-1.961h3.758a.491.491,0,0,0,.235-.06l.233-.127h0a5.112,5.112,0,0,1,5.578.423v5.647H198.1a2.453,2.453,0,0,1-1.261-.349Z",
    transform: "translate(-184.053 -61.36)",
    fill: "#b8ebce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11451",
    "data-name": "Path 11451",
    d: "M551.25,490h.98v.98h-.98Z",
    transform: "translate(-525.269 -463.528)",
    fill: "#b8ebce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11452",
    "data-name": "Path 11452",
    d: "M308.2,210v.98h-.259a1.7,1.7,0,0,0-.761,3.225l2.582,1.291a.722.722,0,0,1-.323,1.367h-2.71v.98H308.2v.98h.98v-.98h.259a1.7,1.7,0,0,0,.761-3.225l-2.582-1.291a.722.722,0,0,1,.323-1.367h2.71v-.98h-1.471V210Z",
    transform: "translate(-293.982 -199.215)",
    fill: "#b8ebce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11453",
    "data-name": "Path 11453",
    d: "M93.223,27.3l3.791,2.843a.49.49,0,0,0,.778-.472L97.4,27.3h1.382a2.454,2.454,0,0,0,2.451-2.451v-4.9A2.454,2.454,0,0,0,98.779,17.5H89.955A2.454,2.454,0,0,0,87.5,19.952v4.9A2.454,2.454,0,0,0,89.955,27.3Zm-4.739-2.451v-4.9a1.47,1.47,0,0,1,1.471-1.471h8.824a1.47,1.47,0,0,1,1.471,1.471v4.9a1.47,1.47,0,0,1-1.471,1.471H96.818a.49.49,0,0,0-.483.571l.287,1.733-2.941-2.206a.49.49,0,0,0-.294-.1H89.955a1.47,1.47,0,0,1-1.471-1.471Z",
    transform: "translate(-87.504 -17.5)",
    fill: "#b8ebce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11454",
    "data-name": "Path 11454",
    d: "M160.06,59.962l4.9-4.9.693.693-4.9,4.9Z",
    transform: "translate(-155.995 -52.956)",
    fill: "#b8ebce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11455",
    "data-name": "Path 11455",
    d: "M141.471,55.442a1.47,1.47,0,1,0-1.04-.431A1.471,1.471,0,0,0,141.471,55.442Zm0-1.961a.49.49,0,1,1-.49.49A.49.49,0,0,1,141.471,53.481Z",
    transform: "translate(-137.059 -50.54)",
    fill: "#b8ebce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11456",
    "data-name": "Path 11456",
    d: "M227.5,106.471a1.47,1.47,0,1,0,.431-1.04A1.471,1.471,0,0,0,227.5,106.471Zm1.961,0a.49.49,0,1,1-.144-.347A.49.49,0,0,1,229.461,106.471Z",
    transform: "translate(-219.657 -100.098)",
    fill: "#b8ebce"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComission);
export default __webpack_public_path__ + "static/media/comission.73fe32788af4ee0cad3b2eed8048ca79.svg";
export { ForwardRef as ReactComponent };